import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import LoadThemeComponent from '../../../../base/LoadThemeComponent';
import { RootState } from '../../redux/store';
import { setNumberOfDraws } from '../../redux/storeSlice';

function NumberOfDrawsSelect() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { multiDrawTicketPackets } = useSelector((state: RootState) => state.playStore);

    const baseView = () => (
        <div className="card options-card d-md-flex h-100">
            <div className="card-header">{t('playPicker.chooseNumberOfDraws')}</div>
            <div className="card-body">
                <div className="row no-gutters justify-content-center flex-column">
                    <div className="col align-items-center form-group mb-0 d-flex">
                        <select
                            name="multiTicketCount"
                            id="multiTicketCount"
                            className="form-control multi-ticket-count select2"
                            onChange={(e) => dispatch(setNumberOfDraws(parseInt(e.currentTarget.value) || 1))}
                        >
                            <option key={1} value="1">
                                1 {t('playPicker.draw')}
                            </option>
                            {multiDrawTicketPackets.map((packet) => (
                                <option key={packet.value} value={packet.value}>
                                    {packet.value} {t('playPicker.draws')}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );

    const [drawCount, setDrawCount] = useState(1);

    const setValidatedDrawCount = (change: number) => {
        setDrawCount((prevCount) => {
            const newCount = Math.max(1, prevCount + change);
            dispatch(setNumberOfDraws(newCount));
            return newCount;
        });
    };

    const defaultView = () => (
        <div className="card options-card d-md-flex h-100">
            <div className="card-header text-center border-bottom-0">Number of draws</div>
            <div className="card-body">
                <div className="col-12 d-flex align-items-center justify-content-center">
                    <button
                        type="button"
                        className="btn button-draw-count d-flex justify-content-center align-items-end"
                        onClick={() => setValidatedDrawCount(-1)}
                    >
                        -
                    </button>
                    <span className="draw-count">{drawCount}</span>
                    <button
                        type="button"
                        className="btn button-draw-count d-flex justify-content-center align-items-end"
                        onClick={() => setValidatedDrawCount(1)}
                    >
                        +
                    </button>
                </div>
            </div>
        </div>
    );

    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}

export default NumberOfDrawsSelect;
